// extracted by css-extract-rspack-plugin
export default {"period_selection":"styles-module__period_selection--mpdlZ"};